import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "ba_access_token";

// Global loading indicator — dispatched via events (subscribed by GlobalLoadingBar)
function dispatchLoading(active) {
  try {
    const ev = new CustomEvent(active ? "api-loading-begin" : "api-loading-end");
    window.dispatchEvent(ev);
  } catch {}
}

export const getStoredToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch { return ""; }
};
export const setStoredToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
};
export const clearStoredToken = () => setStoredToken("");

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  // NOTE: withCredentials NON serve — l'auth è JWT via Bearer header (vedi interceptor sotto).
  // Su iOS Safari + Chrome mobile, withCredentials:true combinato con CORS allow_origins:"*"
  // causa il rifiuto del preflight ("connessione non riuscita"). Disabilitarlo è sicuro.
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

// Inject Bearer token (fallback for mobile/PWA where cross-site cookies are blocked)
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  // Show global loading bar (unless opt-out via config.silent)
  if (!config.silent) dispatchLoading(true);
  return config;
});

// Auto-clear token on 401 from auth/me (avoids stale tokens)
api.interceptors.response.use(
  (r) => {
    if (!r.config?.silent) dispatchLoading(false);
    return r;
  },
  (err) => {
    if (!err?.config?.silent) dispatchLoading(false);
    const url = err?.config?.url || "";
    const status = err?.response?.status;
    if (status === 401 && (url.endsWith("/auth/me") || url.endsWith("/team/me"))) {
      clearStoredToken();
    }
    return Promise.reject(err);
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" • ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
